$(document).ready(function() {
    // Emoji strip utility — strips emoji characters from a string
    function stripEmojis(str) {
        return str.replace(/[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{FE00}-\u{FE0F}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{200D}\u{20E3}\u{E0020}-\u{E007F}]/gu, '');
    }

    // Global emoji stripping on all poster text inputs
    $(document).on('input', '.bp-name-input, .bp-breed-input, .bp-custom-text-input, #bp-photo-heading, #bp-photo-subheading', function() {
        let cleaned = stripEmojis($(this).val());
        if (cleaned !== $(this).val()) {
            $(this).val(cleaned);
        }
    });

    function getStringDate(date, format) {
        return format.replace('[day]', parseInt(date[0])).replace('[day_formatted]', date[0]).replace('[month]', date[1]).replace('[year]', date[2])
    }

    // Heading-font-aware case helper. For the default (Helvetica) font we
    // keep the legacy ALL-CAPS behaviour. For custom fonts (Playfair, Medusa)
    // we render the heading as typed — script + serif fonts look wrong in
    // forced uppercase.
    function casedHeading(value) {
        var font = ($('#bp-heading-font-1').val() || 'default');
        return font === 'default' ? value.toUpperCase() : value;
    }
    function casedSubheading(value) {
        // Subheading always stays uppercase regardless of heading font —
        // the smaller line is the same sans-serif Helvetica in print.
        return value.toUpperCase();
    }

    // --- Name input handler ---
    $('.bp-name-input').on('input change', function(){
        let name = $(this).val();
        let index = $(this).attr('data-index');
        let cased = casedHeading(name);
        if (cased !== name) $(this).val(cased);
        $(`.bp-pet-name[data-index="${index}"]`).text(name.length ? cased : 'HEADING');

        let max_width = $('.bp-poster-info').width() * 0.82;
        let headline = $('.bp-poster-headline');

        let current_width = headline.width()
        if(current_width > max_width) {
            let scale = max_width / current_width;
            headline.css('transform', 'scale(' + scale + ')');
        }
        else {
            headline.css('transform', 'scale(1)');
        }
    });

    // --- Breed input handler ---
    $('.bp-breed-input').on('input change', function(){
        let breed = $(this).val();
        let index = $(this).attr('data-index');
        let cased = casedSubheading(breed);
        if (cased !== breed) $(this).val(cased);
        if(breed.length) {
            $(`.bp-breed[data-index="${index}"]`).text(cased);
        } else {
            $(`.bp-breed[data-index="${index}"]`).text('');
        }
    });

    // --- Date selectors ---
    $('.bp-day-selector').on('change', function(){
        ppSeedPetDate($(this).attr('data-index'));
        let day = $(this).val();
        day = parseInt(day).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
        let index = $(this).attr('data-index');
        let date = $(`.pet-date[data-index="${index}"]`).val();
        date = date.split("-");
        date[0] = day;
        date = date.join("-");
        $(`.pet-date[data-index="${index}"]`).val(date);
        $(`.pet-date[data-index="${index}"]`).change();
    });

    $('.bp-month-selector').on('change', function(){
        ppSeedPetDate($(this).attr('data-index'));
        let month = $(this).find(":selected").attr('data-month');
        let index = $(this).attr('data-index');

        let current_month_days = month_day_object[`${parseInt(month)}`]
        let selected_day = parseInt($(`.bp-day-selector[data-index="${index}"] option:selected`).val());
        let date_format = $(`.pet-date[data-index="${index}"]`).attr("data-format");
        let digits = 1;
        if(date_format.includes("day_formatted")) {
            digits = 2;
        }

        $(`.bp-day-selector[data-index="${index}"]`).empty();
        for (var i = 1; i <= current_month_days; i++) {
            let formatted_number = i.toLocaleString('en-US', { minimumIntegerDigits: digits, useGrouping: false });
            $(`.bp-day-selector[data-index="${index}"]`).append($('<option>', {
                value: `${i}`,
                text: `${formatted_number}`
            }));
        }

        if($(`.bp-day-selector[data-index="${index}"] option[value="${selected_day}"]`).length) {
            $(`.bp-day-selector[data-index="${index}"]`).val(selected_day);
        }
        else {
            $(`.bp-day-selector[data-index="${index}"]`).val(1);
        }
        // Set the month in pet-date before triggering day change,
        // so the day handler cascade picks up the correct month
        let date = $(`.pet-date[data-index="${index}"]`).val();
        date = date.split("-");
        date[1] = month;
        date = date.join("-");
        $(`.pet-date[data-index="${index}"]`).val(date);

        // Trigger day change which cascades to pet-date change (single fire)
        $(`.bp-day-selector[data-index="${index}"]`).change();
    });

    $('.bp-year-selector').on('change', function(){
        ppSeedPetDate($(this).attr('data-index'));
        let year = $(this).val();
        let index = $(this).attr('data-index');
        let date = $(`.pet-date[data-index="${index}"]`).val();
        date = date.split("-");
        date[2] = year;
        date = date.join("-");
        $(`.pet-date[data-index="${index}"]`).val(date);
        $(`.pet-date[data-index="${index}"]`).change();
    });

    // The date starts empty, so nothing is printed unless the customer chooses
    // one (order #1112 shipped "JANUARY 1, 2026" from a pre-filled default the
    // customer never touched). The selector handlers below mutate one component
    // of that stored dd-mm-yyyy string, which cannot work from an empty value —
    // so seed it from the selectors the first time any of them is used.
    function ppSeedPetDate(index) {
        var $hidden = $('.pet-date[data-index="' + index + '"]');
        if (($hidden.val() || '').split('-').length === 3) return;
        var day = $('.bp-day-selector[data-index="' + index + '"]').val() || '1';
        var month = $('.bp-month-selector[data-index="' + index + '"] option:selected').attr('data-month')
                 || $('.bp-month-selector[data-index="' + index + '"] option:first').attr('data-month') || '01';
        var year = $('.bp-year-selector[data-index="' + index + '"]').val() || String(new Date().getFullYear());
        $hidden.val(('0' + day).slice(-2) + '-' + ('0' + month).slice(-2) + '-' + year);
    }

    $('.pet-date').on('change', function(){
        let date = $(this).val();
        let index = $(this).attr('data-index');
        let format = $(this).attr('data-format');
        date = date.split("-");

        let monthOption = $(`.bp-month-selector[data-index="${index}"]`).find(`[data-month=${date[1]}]`);
        if(!monthOption.length) return; // selectors not populated yet

        $(`.bp-day-selector[data-index="${index}"]`).val(parseInt(date[0]))
        $(`.bp-month-selector[data-index="${index}"]`).val(monthOption.val());
        $(`.bp-year-selector[data-index="${index}"]`).val(date[2])

        date[1] = monthOption.val().toUpperCase();
        date = getStringDate(date, format);
        $(`.bp-date[data-index="${index}"]`).text(`${date}`)
        $(`#date-current-${index}`).val(`${date}`)
    });

    // --- Illustration value handler ---
    $('.bp-illustration-value').on('change', function(){
        let illustration = $(this).val();
        let index = $(this).attr('data-index');
        if (parseInt(index) > 1)
        $(`.bp-variant-options-radio[data-index="${index}"][data-value="${illustration}"]`).click();
    });

    // --- Custom Text Toggle (Feature 1) ---
    function assembleSubheading(index) {
        let breed = ($('.bp-breed-input[data-index="' + index + '"]').length) ? $('.bp-breed-input[data-index="' + index + '"]').val() : '';
        let date = ($(`#date-current-${index}`).length) ? $(`#date-current-${index}`).val() : '';
        return [breed, date].filter(str => str !== "").join(' / ').trim();
    }

    function updateSubheadingPreview(index, text) {
        var containers = ['.petposter-template', '.hidden-preview'];
        containers.forEach(function(container) {
            let subheadings = $(`${container} .bp-poster-subheading`);
            let el = subheadings.eq(index - 1);
            if(el.length) {
                el.html(`<span class="bp-custom-subheading">${text}</span>`);
            }
        });

        let parentInfo = $('.petposter-template .bp-poster-info');
        let max_width = parentInfo.width() * 0.82;
        let subEl = $('.petposter-template .bp-poster-subheading').eq(index - 1);
        let current_width = subEl.width();
        if(current_width > max_width) {
            let scale = max_width / current_width;
            subEl.css('transform', 'scale(' + scale + ')');
        } else {
            subEl.css('transform', 'scale(1)');
        }
    }

    // Store original subheading HTML for each pet to restore when toggling back
    let originalSubheadingHTML = {};
    let originalHiddenSubheadingHTML = {};

    // The section is hidden now (see petposter.css). A design saved while it was
    // switched on still restores with its flag set, so give those their way back
    // out — checked after the restore has had time to run.
    setTimeout(function () {
        $('.bp-custom-text-flag').each(function () {
            if (($(this).val() || '') === 'true') {
                $(this).closest('.bp-custom-text-section').addClass('pp-custom-text-in-use');
            }
        });
    }, 1200);

    $('.bp-custom-text-toggle').on('click', function(){
        let index = $(this).attr('data-index');
        let container = $(`.bp-custom-text-container[data-index="${index}"]`);
        let textarea = $(`#bp-custom-text-${index}`);
        let flag = $(`#bp-custom-text-flag-${index}`);
        let isActive = container.is(':visible');

        if(!isActive) {
            // Activate custom text mode — only pre-fill if textarea is empty (preserves restored value)
            if(!textarea.val().trim()) {
                let currentSubheading = assembleSubheading(index);
                textarea.val(currentSubheading.toUpperCase());
            }
            container.show();
            // Trigger `change` so the pp-local-storage-handler change listener
            // writes the flag to localStorage. Without this, page reloads can't
            // restore the "Customize subheading" active state because the flag
            // was set via .val() (which jQuery doesn't fire change events for).
            flag.val('true').trigger('change');

            // Save original subheading HTML (both visible and hidden preview)
            originalSubheadingHTML[index] = $('.petposter-template .bp-poster-subheading').eq(parseInt(index) - 1).html();
            originalHiddenSubheadingHTML[index] = $('.hidden-preview .bp-poster-subheading').eq(parseInt(index) - 1).html();

            // Update the preview with current text
            updateSubheadingPreview(index, textarea.val());

            // Dim structured fields (but keep pet name + font picker editable —
            // font is orthogonal to text content, customer should still be able
            // to switch fonts while custom text is active).
            $(this).closest('.bp-sidebar-item-content').find('.bp-sidebar-object').not('.bp-custom-text-section').not('.bp-font-picker-section').not(':has(.bp-name-input[id^="bp-name"])').addClass('bp-sidebar-object-dimmed');

            // Toggle button labels
            $(this).find('.bp-custom-text-toggle-label').hide();
            $(this).find('.bp-custom-text-toggle-back').show();
        } else {
            // Deactivate custom text mode
            container.hide();
            textarea.val('');
            // Fire change so localStorage persists the cleared state.
            flag.val('').trigger('change');

            // Un-dim structured fields first (before triggering changes)
            $(this).closest('.bp-sidebar-item-content').find('.bp-sidebar-object').removeClass('bp-sidebar-object-dimmed');

            // Toggle button labels
            $(this).find('.bp-custom-text-toggle-label').show();
            $(this).find('.bp-custom-text-toggle-back').hide();

            // Restore original subheading HTML (both visible and hidden preview)
            if(originalSubheadingHTML[index]) {
                $('.petposter-template .bp-poster-subheading').eq(parseInt(index) - 1).html(originalSubheadingHTML[index]);
                $('.hidden-preview .bp-poster-subheading').eq(parseInt(index) - 1).html(originalHiddenSubheadingHTML[index]);
                let subEl = $('.petposter-template .bp-poster-subheading').eq(parseInt(index) - 1);
                subEl.css('transform', 'scale(1)');
            }

            // Re-trigger field updates to refresh preview
            $(`.bp-breed-input[data-index="${index}"]`).change();
            $(`.pet-date[data-index="${index}"]`).change();
        }
    });

    // Real-time preview update when typing in custom text textarea
    $('.bp-custom-text-input').on('input', function(){
        let index = $(this).attr('data-index');
        let text = $(this).val().toUpperCase();
        let start = this.selectionStart;
        let end = this.selectionEnd;
        $(this).val(text);
        this.setSelectionRange(start, end);
        updateSubheadingPreview(index, text);
    });

    // Auto-contrast: detect background luminance and switch text color
    function updateTextContrast() {
        // Fill mode first: there the text does not sit on the background colour
        // at all, it sits on the artwork, over the dark scrim the fill handler
        // puts behind it — so it is white whatever swatch is selected. Without
        // this, picking a light background while filling turned the name dark
        // and it vanished into the scrim. It is the normal state on canvas,
        // which fills by default.
        if ($('.petposter-template').hasClass('fill-poster')) {
            $('.bp-poster-headline, .bp-poster-subheading, .bp-pet-name, .bp-breed, .bp-date, .bp-poster-info').css('color', '#ffffff');
            $('.hidden-preview .bp-poster-headline, .hidden-preview .bp-poster-subheading, .hidden-preview .bp-pet-name, .hidden-preview .bp-breed, .hidden-preview .bp-date, .hidden-preview .bp-poster-info').css('color', '#ffffff');
            return;
        }

        var bgColor = $('.bp-background-radio:checked').attr('data-color') || '#FFFFFF';

        // Parse hex color to RGB
        var hex = bgColor.replace('#', '');
        if (hex.length === 3) hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
        var r = parseInt(hex.substring(0, 2), 16);
        var g = parseInt(hex.substring(2, 4), 16);
        var b = parseInt(hex.substring(4, 6), 16);

        // Calculate relative luminance (WCAG formula)
        var luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

        var textColor = luminance > 0.5 ? '#1a1a1a' : '#ffffff';

        // Apply to poster text elements
        $('.bp-poster-headline, .bp-poster-subheading, .bp-pet-name, .bp-breed, .bp-date, .bp-poster-info').css('color', textColor);
        // Also update hidden preview
        $('.hidden-preview .bp-poster-headline, .hidden-preview .bp-poster-subheading, .hidden-preview .bp-pet-name, .hidden-preview .bp-breed, .hidden-preview .bp-date, .hidden-preview .bp-poster-info').css('color', textColor);
    }


    // BACKGROUND COLOUR only exists when some of the sheet is left to colour.
    //
    // generate-pdf paints the whole page in this colour and then draws the
    // artwork over it, so with FILL POSTER on the only places it can still be
    // seen are wherever the artwork happens to be transparent. That is not a
    // choice anyone is making on purpose — it reads as colour bleeding through
    // the picture, and on canvas, which fills by default, it is the first thing
    // you notice.
    //
    // So the control is shown exactly when it does something. This is not
    // canvas-specific on purpose: a filled paper poster has the same problem,
    // it is just rarer to land on.
    function syncBackgroundVisibility() {
        var filled = $('.petposter-template').hasClass('fill-poster');
        $('.bp-background-radio').first().closest('.bp-sidebar-object')
            .toggle(!filled);
    }

    // Paint the poster from a background swatch.
    function applyBackground(el) {
        if (!el || !el.length) return;
        var color = el.attr('data-color');
        if (color) {
            $('.bp-poster-preview').css('background-color', color);
            $('.bp-poster-preview').css('background-image', 'none');
        }
        var image = el.attr('data-image');
        if (image) {
            $('.bp-poster-preview').css('background-image', 'url(' + image + ')');
            $('.bp-poster-preview').css('background-color', 'transparent');
        }
    }

    // Run on background change — apply color to poster and update contrast
    $(document).on('change', '.bp-background-radio', function() {
        applyBackground($(this));
        updateTextContrast();
    });

    // Run on page load — and PAINT it, not just read it.
    //
    // A remembered background comes back by checking its radio, and only the
    // change handler above ever painted the poster. So the swatch said dark
    // while the poster stayed white, and the contrast rule, which goes by the
    // swatch, wrote white text onto a white poster: the pet's name simply
    // disappeared until you touched a background again.
    setTimeout(function () {
        applyBackground($('.bp-background-radio:checked'));
        updateTextContrast();
        syncBackgroundVisibility();
    }, 500);

    // Poster aspect ratio per size
    var sizeRatios = {
        '2130': 142.86,   // 30/21 = 1.4286
        '812':  150.00,   // 12/8 = 1.5
        '3040': 133.33,   // 40/30 = 1.3333
        '1216': 133.33,   // 16/12 = 1.3333
        '5070': 140.00,   // 70/50 = 1.4
        '2028': 140.00,   // 28/20 = 1.4
        '6191': 149.18,   // 91/61 = 1.4918
        '2436': 150.00,   // 36/24 = 1.5
        '70100': 142.86,  // 100/70 = 1.4286
        '2840': 142.86,   // 40/28 = 1.4286
    };

    function updatePosterRatio() {
        var selectedTitle = $('input.bp-variant-options-radio:checked').closest('fieldset').find('input.bp-variant-options-radio:checked').val() || '';
        // Extract numbers from the title to find the ratio
        var numbers = selectedTitle.match(/(\d+)x(\d+)/);
        if (numbers) {
            var w = parseInt(numbers[1]);
            var h = parseInt(numbers[2]);
            var ratio = (h / w) * 100;
            $('.bp-poster-preview').css('padding-bottom', ratio + '%');
        }
    }

    // ─── Price system ───
    // Delegate to the locale-aware global formatter (pp-money.js). The legacy
    // window.currencySymbol path produced symbol-before-amount output even for
    // currencies whose convention is suffix (kr, ¥ in some locales, etc.).
    function formatPrice(amountInCents) {
        if (window.ppFormatMoney) return window.ppFormatMoney(amountInCents);
        var symbol = (typeof window.currencySymbol !== 'undefined') ? window.currencySymbol : '€';
        var amount = amountInCents / 100;
        return symbol + amount.toFixed(2).replace('.', ',');
    }

    function getSelectedSize() {
        // The radio has the raw value (with "), dropdown has escaped (&quot;)
        return $('input.bp-variant-options-radio:checked').val() || ($('#bp-size-dropdown').val() || '').replace(/&quot;/g, '"');
    }

    function getSelectedPosterPrice() {
        var selectedSize = getSelectedSize();
        if (typeof window.variantPrices !== 'undefined' && window.variantPrices[selectedSize]) {
            return window.variantPrices[selectedSize].price; // in cents
        }
        return 0;
    }

    function getSelectedFramePrice() {
        var frameRadio = $('.bp-frame-radio:checked');
        if (!frameRadio.length || frameRadio.attr('data-price-actual') === '0') {
            return { price: 0, formatted: formatPrice(0) };
        }

        var frameTitle = frameRadio.attr('data-title') || '';
        var selectedSize = getSelectedSize();

        // Look up frame price for the current size from frameData
        if (typeof window.frameData !== 'undefined') {
            for (var handle in window.frameData) {
                if (window.frameData[handle].title === frameTitle) {
                    var sizeData = window.frameData[handle].variants[selectedSize];
                    if (sizeData) {
                        return { price: sizeData.price, formatted: sizeData.priceFormatted };
                    }
                }
            }
        }

        // Fallback to the data attribute (in decimal, need to convert to cents)
        var actual = parseFloat(frameRadio.attr('data-price-actual') || '0');
        return { price: Math.round(actual * 100), formatted: frameRadio.attr('data-price') || formatPrice(0) };
    }

    function updateTotalPrice() {
        var posterPrice = getSelectedPosterPrice();
        var frame = getSelectedFramePrice();
        var total = posterPrice + frame.price;

        $('.bp-order-price').attr('data-cents', total).text(formatPrice(total));
        // Frame "+X" badge: use raw cents from frame lookup, format locale-aware.
        if (frame.price > 0) {
            $('.bp-selected-frame-price').attr('data-cents', frame.price).text('+ ' + formatPrice(frame.price));
        } else {
            $('.bp-selected-frame-price').attr('data-cents', '').text('');
        }

        // Re-apply the 20% cart-discount preview after we just rewrote the
        // total. This handler fires LAST in the frame-change chain (delegated
        // via $(document).on) and was wiping the discount applied by the other
        // two frame handlers.
        if (typeof window._ppUpdateDiscountPreview === 'function') {
            var frameSelected = frame.price > 0;
            window._ppUpdateDiscountPreview(total, frameSelected);
        }
    }

    // Update on variant/size change
    $(document).on('change', '.bp-variant-options-radio', function() {
        updatePosterRatio();
        var val = $(this).val();
        if (val && $('#bp-size-dropdown').length) {
            $('#bp-size-dropdown').val(val);
        }
        // Update the size label below poster
        var sizeLabel = val ? val.replace(/"/g, '″') : '';
        $('.bp-poster-bottom-size').text(sizeLabel);
        updateTotalPrice();
    });

    // Update on frame change
    $(document).on('change', '.bp-frame-radio', function() {
        $('.bp-frame-selected-value').text($(this).attr('data-title'));
        updateTotalPrice();
    });

    // Initial price set
    setTimeout(updateTotalPrice, 600);

    // Set initial ratio
    setTimeout(updatePosterRatio, 300);

    // Fill poster toggle
    $('#bp-fill-poster-toggle').on('change', function() {
        var fill = $(this).is(':checked');

        if (fill) {
            // Add class so CSS can override .pp-no-text's !important padding
            $('.petposter-template, .hidden-preview .petposter-template').addClass('fill-poster');
            syncBackgroundVisibility();
            // Make illustration fill the entire poster (cover text area too)
            $('.bp-preview-illustration-cont').css({
                'height': '100%',
                'padding': '0'
            });
            $('.bp-poster-info').css({
                'position': 'absolute',
                'bottom': '0',
                'left': '0',
                'right': '0',
                'background': 'linear-gradient(transparent, rgba(0,0,0,0.5))',
                'padding': '8% 5% 4%',
                'z-index': '3',
                'height': 'auto',
                'width': '100%'
            });
            // Force white text when fill mode (illustration likely covers background)
            $('.bp-poster-headline, .bp-poster-subheading, .bp-pet-name, .bp-breed, .bp-date, .bp-poster-info').css('color', '#ffffff');
            $('.hidden-preview .bp-poster-headline, .hidden-preview .bp-poster-subheading, .hidden-preview .bp-pet-name, .hidden-preview .bp-breed, .hidden-preview .bp-date, .hidden-preview .bp-poster-info').css('color', '#ffffff');

            // Also apply to hidden preview
            $('.hidden-preview .bp-preview-illustration-cont').css({ 'height': '100%', 'padding': '0' });
            $('.hidden-preview .bp-poster-info').css({
                'position': 'absolute', 'bottom': '0',
                'left': '0', 'right': '0',
                'background': 'linear-gradient(transparent, rgba(0,0,0,0.5))',
                'padding': '8% 5% 4%', 'z-index': '3', 'height': 'auto',
                'width': '100%'
            });
        } else {
            // Remove class first so any CSS-driven overrides drop back
            $('.petposter-template, .hidden-preview .petposter-template').removeClass('fill-poster');
            syncBackgroundVisibility();
            // Restore original layout
            $('.bp-preview-illustration-cont').css({ 'height': '', 'padding': '' });
            $('.bp-poster-info').css({
                'position': '', 'bottom': '', 'left': '', 'right': '',
                'background': '', 'padding': '', 'z-index': '', 'height': '',
                'width': ''
            });
            $('.hidden-preview .bp-preview-illustration-cont').css({ 'height': '', 'padding': '' });
            $('.hidden-preview .bp-poster-info').css({
                'position': '', 'bottom': '', 'left': '', 'right': '',
                'background': '', 'padding': '', 'z-index': '', 'height': '',
                'width': ''
            });
            // Re-run auto-contrast
            if (typeof updateTextContrast === 'function') updateTextContrast();
        }
    });
});
